import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { fetchRecommendedUsers } from "store/recommendedUsers/recommendedUsers.actions";

import AttendingEventsSection from "../AttendingEventSection";
import {
  AddButton,
  CompanyName,
  LogoContainer,
  LogoImg,
  RecommendCard,
  Section,
  SectionTitle,
  ShowMoreLink,
  Sidebar
} from "./FeedRightSidebar.styles";


const FeedRightSidebar: React.FC = () => {
  /*const companies = [
    {
      id: 1,
      name: "Meta",
      logoUrl:
        "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      id: 2,
      name: "Twitter",
      logoUrl:
        "https://images.unsplash.com/photo-1611605698335-8b1569810432?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
  ];*/

  const { data: recommendedUsers } = useAppSelector(state => state.recommendedUsers);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchRecommendedUsers());
  }, []);

  return (
    <Sidebar>
      {/* recomendaciones */}
      <Section>
        <SectionTitle>Recommendations</SectionTitle>
        {recommendedUsers.map((recommendedUser, key) => (
          <RecommendCard key={key}>
            <LogoContainer>
              <LogoImg src={recommendedUser.socialAvatarUrl} alt={recommendedUser.name} />
            </LogoContainer>

            <CompanyName>{recommendedUser.name}</CompanyName>

            <AddButton onClick={() => console.log(recommendedUser.id)}>
              <PersonAddAlt1Icon fontSize="medium" />
            </AddButton>
          </RecommendCard>
        ))}

        <ShowMoreLink>Show more</ShowMoreLink>
      </Section>

      {/* events */}
      <AttendingEventsSection />
    </Sidebar>
  );
};

export default FeedRightSidebar;
